<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="500"
    v-model="localShow"
  >
    <v-card color="be-data-table-stripes">
      <v-toolbar :color="computedColor" dark class="text-on-primary--text">{{message.title}}</v-toolbar>
      <v-card-text v-if="message.message" style="background-color: var(--v-be-dialog-base) !important">
        <template>
          <p style="padding-top: 10px" v-if="typeof message.message == 'string'">{{message.message }}</p>
          <p style="padding-top: 10px" v-else v-for="item in message.message" :key="item">{{item}}</p>
        </template>
      </v-card-text>
      <slot>
      </slot>
      <v-card-actions class="justify-end">
        <v-btn
          color="be-primary" 
          dark
          elevation="0"
          class="text-on-primary--text"
          @click="localShow = false"
        >OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "be-modal-message",

  props: {
    show: {
      type: Boolean,
      required: false,
    },
    color: {
      type: String,
      default: 'be-primary'
    },
    message: {
      type: Object
    }
  },

  data() {
    return {
      localShow: false,
    };
  },

  computed: {
    computedColor() {
      if(!this.color) {
        return 'be-primary'
      }
      return this.color
    }
  },

  watch: {
    show(val) {
      this.localShow = val;
    },
    localShow(val) {
        if(!val) {
            this.$emit('refreshPage')
        }
    },
  },
};
</script>

<style>
</style>